import { Component } from "react";
import "./ServicesStyles.css"
import { LazyLoadImage } from "react-lazy-load-image-component"


class ServicesData extends Component{
    render(){
        return(
            <div className={this.props.className}>
                <div className="des-text">
                    <h2>{this.props.heading}</h2>
                    <p>{this.props.text}
                        </p>
                </div>
                <div className="image">
                <LazyLoadImage  alt="img" src={this.props.img1} />
                <LazyLoadImage alt="img" src={this.props.img2}/>
            </div>
            </div>
        )
    }

}

export default ServicesData;